import { useEffect } from 'react';

interface AvoidAutoComplete {
  idsToAvoidAutoComplete?: string[];
  inputsWrapper?: HTMLDivElement;
}

export const useAvoidAutoComplete = ({
  idsToAvoidAutoComplete,
  inputsWrapper,
}: AvoidAutoComplete) => {
  const avoidAutoComplete = (elements: HTMLInputElement[]) => {
    elements.forEach((i) => {
      i.setAttribute('autocomplete', 'new-password');
    });
  };

  useEffect(() => {
    if (inputsWrapper) {
      const inputNodes = inputsWrapper.querySelectorAll('input');
      avoidAutoComplete(Array.from(inputNodes) as HTMLInputElement[]);
    }
  }, [inputsWrapper]);

  useEffect(() => {
    const inputList: HTMLInputElement[] = [];
    idsToAvoidAutoComplete?.forEach((id) => {
      const innerInput = document.getElementById(id);
      if (innerInput) {
        inputList.push(innerInput as HTMLInputElement);
      }
    });
    avoidAutoComplete(inputList);
  }, [idsToAvoidAutoComplete]);
};
